import { IStateMallCategory } from '../../entity/StateEntity';
import {
  MALL_CATEGORY_STATUS_RELOAD,
  MALL_CATEGORY_STATUS_SUCCESS,
  MALL_CATEGORY_STATUS_REQUEST,
  MALL_CATEGORY_STATUS_FAILURE,
} from 'src/constants/ActionTypes';

const initialState: IStateMallCategory = {
  reload: true,
  isFetching: false,
  type: MALL_CATEGORY_STATUS_RELOAD,
  categoryList: [],
};

export const mallCategoryState = (state: IStateMallCategory = initialState, action: IStateMallCategory): IStateMallCategory => {
  switch (action.type) {
    case MALL_CATEGORY_STATUS_SUCCESS:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        categoryList: action.categoryList,
      });

    case MALL_CATEGORY_STATUS_REQUEST:
      return Object.assign({}, state, {
        reload: false,
        isFetching: true,
        type: action.type,
        categoryList: [],
      });

    case MALL_CATEGORY_STATUS_RELOAD:
      return Object.assign({}, state, {
        reload: true,
        isFetching: false,
        type: action.type,
        categoryList: [],
      });

    case MALL_CATEGORY_STATUS_FAILURE:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        categoryList: [],
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/mallCategoryState.ts